import axios from 'axios';
import { settings } from '@/plugins/settings';

const base = () => settings.endpoint + 'communities';

export const communityService = {

  fetchAll(): Promise<any[]> {
    return axios({ url: base() + '/all', method: 'GET' }).then((response: any) => {
      if (response && response.data && Array.isArray(response.data.data)) return response.data.data;
      if (response && Array.isArray(response.data)) return response.data;
      return [];
    });
  },

  fetchCities(): Promise<string[]> {
    return axios({ url: base() + '/cities', method: 'GET' }).then((response: any) => {
      if (response && response.data && Array.isArray(response.data.data)) return response.data.data;
      if (response && Array.isArray(response.data)) return response.data;
      return [];
    });
  },

  fetchRentbackList(params: any = {}): Promise<any> {
    return axios({ url: base() + '/rentback', method: 'GET', params }).then((response: any) => {
      return response.data.data;
    });
  },


  fetchLockers(communityId: number, params: any = {}): Promise<any> {
    return axios({ url: base() + '/' + communityId + '/lockers', method: 'GET', params })
      .then((r: any) => r.data && r.data.data);
  },

  exportCommunities(filters: any = {}): Promise<any[]> {
    return axios({ url: base() + '/export', method: 'GET', params: filters }).then((response: any) => {
      if (response && response.data && Array.isArray(response.data.data)) return response.data.data;
      if (response && Array.isArray(response.data)) return response.data;
      return [];
    });
  },

};
